import Link from '@/components/utilities/SmartLink';
import { getImagePath } from '@/utils/images';

const EbookSidebarCta = ({ title, description, buttonLabel, buttonLink, note, logo }) => {
  if (!title && !buttonLabel) return null;

  const logoSrc = logo?.url ? getImagePath(logo) : '/leadhub-logo-white.svg';
  const logoAlt = logo?.alternativeText || 'Leadhub';

  return (
    <div className="bg-grey-950 rounded-2xl p-6 text-white">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={logoSrc} alt={logoAlt} className="mb-5 block h-[22px] w-auto" />
      {title && <h3 className="mb-2.5 text-lg text-white">{title}</h3>}
      {description && <p className="mb-5 text-sm leading-relaxed text-white/60">{description}</p>}
      {buttonLabel && buttonLink && (
        <Link
          href={buttonLink}
          className="bg-brand-400 hover:bg-brand-500 flex w-full items-center justify-center rounded-full px-5 py-3 text-sm font-medium text-white transition-colors"
        >
          {buttonLabel}
        </Link>
      )}
      {note && <p className="mt-2.5 text-center text-xs text-white/35">{note}</p>}
    </div>
  );
};

export default EbookSidebarCta;
